<template lang="html">
    <div>
        <div class="columns">
            <div class="column is-3">
                <b-field class="file">

                    <a>
                        <figure class="image is-circle">
                            <div class="overlay">

                            </div>
                            <img src="/img/user.png">
                        </figure>
                    </a>

                </b-field>
            </div>
            <div class="column">
                <form-input name="name" v-model="user.profile.name" :error="errors.name" holder="Pepe" label="Nombre"
                            type="text"/>
                <form-input name="last_name" v-model="user.profile.last_name" :error="errors.last_name" holder="Perez"
                            label="Apellido Paterno" type="text"/>
                <form-input name="other_name" v-model="user.profile.other_name" :error="errors.other_name"
                            holder="Lopez" label="Apellido Materno" type="text"/>
                <form-input name="email" v-model="user.email" :error="errors.email" holder="pepe@empresa.com.mx"
                            label="Correo electrónico" type="email" />

                <b-field label="Fecha de nacimiento">
                    <b-datepicker placeholder="Clic para seleccionar" icon="calendar-alt" v-model="birthday"
                                  @input="setDate">

                    </b-datepicker>
                </b-field>

                <div class="columns">
                    <div class="column">
                        <div v-if="admin && user.role !== 'super'">
                            <form-select v-model="user.role" :error="errors.role" :options="roles" label="Tipo de Usuario" />
                        </div>
                    </div>
                    <div class="column" v-if="this.$auth.check(['root']) && user.role === 'ivr_worker' && createForm">
                        <div>
                            <form-select v-model="user.provider" :error="errors.provider" :options="providers" label="Departamento" />
                        </div>
                    </div>
                    <div class="column">
                        <b-field label="Genero">
                            <div class="block">
                                <b-radio v-model="user.profile.gender" native-value="male">
                                    Masculino
                                </b-radio>
                                <b-radio v-model="user.profile.gender" native-value="feme">
                                    Femenino
                                </b-radio>
                            </div>
                        </b-field>
                    </div>
                </div>

                <div class="columns">
                    <div class="column">
                        <div v-if="user.role === 'ivr_worker'">
                            <div v-if="admin && user.role !== 'super'">
                                <form-input name="extension" v-model="user.extension" :error="errors.extension" holder="Num. Extensión"
                                            label="Extensión" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div v-if="user.role === 'ivr_worker'">
                            <div v-if="admin && user.role !== 'super'">
                                <form-input name="personal_phone" v-model="user.personal_phone" :error="errors.personal_phone" holder="+521 5555 5555"
                                            label="Teléfono" type="text" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="columns">
            <div class="column">
                <form-input name="password" v-model="user.password" :error="errors.password" holder="●●●●●●●" label="Contraseña" type="password" reveal />
            </div>
            <div class="column">
                <form-input name="password_confirmation" v-model="user.password_confirmation"
                            :error="errors.password_confirmation" holder="●●●●●●●" label="Confirmación" type="password" reveal/>
            </div>

        </div>
        <b-modal :active.sync="isImageModalActive">
            <div class="card">
                <div class="card-content">
                    <vue-cropper ref="cropper" :src="avatar" alt="Avatar" :guides="true" :aspect-ratio="1">
                    </vue-cropper>
                </div>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="isImageModalActive = false">Cerrar</button>
                    <button class="button is-primary" type="button" @click="cropImage">Guardar Imagen</button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {

                loading: false,
                files: [],
                isImageModalActive: false,
                avatar: '/images/user.png',
                roles: [
                    {value: 'admin', label: 'Administrador'},
                    {value: 'ivr_worker', label: 'Operador'},
                ],
                birthday: new Date(),
                providersData: []
            }
        }, beforeUpdate() {
            this.birthday = new Date(this.user.profile.birthday);

        },
        props: {
            user: {
                required: true,
                type: Object,
            },
            errors: {
                required: true,
                type: Object,
            },
            createWorker: false,
            createForm: false
        },
        computed: {
            admin() {
                if (this.$auth.check('root')) {
                    this.roles[2] = {value: 'root', label: 'Root'};
                }
                return this.$auth.check(['admin', 'super', 'root'])
            },
            providers() {
                const data = [];
                for(const i of this.providersData){
                    data.push({value: i.slug, label: i.name});
                }
                return data;
            }
        },
        mounted() {
            this.prepareComponent();
        },
        methods: {
            prepareComponent(){
                this.getData();
            },
            getData(){
                if(this.$auth.check('root') && this.createForm){
                    this.getProviders();
                }
            },
            getProviders(){
                this.$http.get('/ivr/provider').then(response => {
                    this.providersData = response.data.data;
                });
            },
            cropImage() {
                // get image data for post processing, e.g. upload or setting image src
                this.avatar = this.$refs.cropper.getCroppedCanvas().toDataURL();
                let file = this.$refs.cropper.getCroppedCanvas();
                file.toBlob(blob => {
                    this.user.file = blob
                });
                this.isImageModalActive = false
            },
            changeAvatar(files) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    this.isImageModalActive = true;
                    setTimeout(() => {
                        this.$refs.cropper.replace(reader.result);
                    }, 10)
                };
                reader.readAsDataURL(files);
            },
            setDate(val) {
                this.user.profile.birthday = moment(val).format();
            }
        }
    }
</script>

<style lang="css">
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: auto;
        text-align: center;
    }

    .avatar-uploader img {
        width: 178px;
        height: auto;
        display: block;
    }
</style>
